import * as Yup from "yup";
import { getPatchOperations } from "../../../util/form";

export const adminUdenlandskAdvokatsamfundFormConfig = (
  id?: string,
): FormConfig<UdenlandskAdvokatsamfundDTO> => {
  return {
    title: "Udenlandsk advokatsamfund",
    lockedValues: [{ id: "id", value: id }],
    validationSchema: Yup.object({
      navn: Yup.string().required("Påkrævet").max(30, "Maks 30 tegn"),
    }),
    form: [
      {
        component: "textinput",
        id: "navn",
        initialValue: "",
        label: "Navn",
        placeholder: "",
        isRequired: true,
      },
      {
        component: "textinput",
        id: "beskrivelse",
        initialValue: "",
        label: "Beskrivelse",
        placeholder: "",
        isRequired: false,
      },
    ],
    get: `udenlandskadvokatsamfund/${id}`,
    post(values) {
      return {
        query: `udenlandskadvokatsamfund`,
        body: values,
      };
    },
    patch(values) {
      return {
        query: `udenlandskadvokatsamfund/${id}`,
        body: JSON.stringify(getPatchOperations(values)),
      };
    },
  };
};
